import { capabilities } from 'navigation-components/capabilities';
import { useInvokeCapability } from 'navigation-components/consumer/hooks';
import { useEffect } from 'react';
export const useSetIframePosition = ({
  iframeRightOffset,
  iframeTopOffset
}) => {
  const changeIframeStyle = useInvokeCapability(capabilities.RESTYLE_CAP);
  useEffect(() => {
    changeIframeStyle({
      style: {
        right: `${iframeRightOffset}px`,
        top: `${iframeTopOffset}px`
      },
      merge: true
    });
  }, [changeIframeStyle, iframeRightOffset, iframeTopOffset]);
};